import * as api from '../../api/api-consulta-emision-pagos';
import {
    GET_EMISIONES_PAGOS,
    GET_RESUMEN_COMPANIA_EMISION,
    GET_DETALLE_PAGOS_EMISION,
    GET_ESTADO_INFORME_EMISION,
    POST_REGENERAR_INFORME_EMISION,
    GET_VER_CUPON_EMISION
} from '../types';

export const buscarEmisionesAction = (query) => ({
    type: GET_EMISIONES_PAGOS,
    payload: api.serviceBuscarEmisiones(query)
});

export const obtenerResumenPorCompaniaAction = (query) => ({
    type: GET_RESUMEN_COMPANIA_EMISION,
    payload: api.serviceObtenerResumenPorCompania(query)
});

export const obtenerDetallePagosAction = (query) => ({
    type: GET_DETALLE_PAGOS_EMISION,
    payload: api.serviceObtenerDetallePagos(query)
});

export const obtenerEstadoInformeEmisionAction = (query) => ({
    type: GET_ESTADO_INFORME_EMISION,
    payload: api.serviceObtenerEstadoEmision(query)
});

export const regenerarInformeEmisionAction = (body) => ({
    type: POST_REGENERAR_INFORME_EMISION,
    payload: api.serviceRegenerarInforme(body)
});

export const verCuponAction = (query) => ({
    type: GET_VER_CUPON_EMISION,
    payload: api.serviceVerCupon(query)
});
